'use es6';

import { PRESET_TYPES } from '../lib/AdsSimpleDateRange';
import { toMoment } from 'UIComponents/core/SimpleDate';
const MINUS_ONE_END = [PRESET_TYPES.LAST_THIRTY_DAYS, PRESET_TYPES.LAST_THREE_MONTHS];
const MINUS_ONE_START = [PRESET_TYPES.LAST_THIRTY_DAYS];
export const calculateMomentTimeRange = timeRange => {
  const startDate = toMoment(timeRange.startDate);
  const endDate = toMoment(timeRange.endDate);

  if (MINUS_ONE_START.includes(timeRange.type)) {
    startDate.subtract(1, 'day');
  }

  if (MINUS_ONE_END.includes(timeRange.type) && endDate > startDate) {
    endDate.subtract(1, 'day');
  }

  return {
    startDate,
    endDate
  };
};

const calculateTimeRange = timeRange => {
  const range = calculateMomentTimeRange(timeRange);
  return {
    'date-start': range.startDate.format('YYYYMMDD'),
    'date-end': range.endDate.format('YYYYMMDD')
  };
};

export default calculateTimeRange;